import { SVGProps } from 'react';

const SvgMinusSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M12.5 8a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h8a.5.5 0 0 1 .5.5Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgMinusSmall;
